import Pays from "./extend/classes/Pays";

export default class DefaultValue {
  public static defaultValueMap = new Map<string, number>;

  public static initialise(): void {
    Pays.getByCode("FR").then((res) => {
        DefaultValue.defaultValueMap.set("pays", res.id);
      }).catch((err) => {
        console.log(err);
      });
    }
}